/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { NO_MARGIN_BOTTOM } from '@constants';
import { SortableArrayField, TextField, ContentModuleModal, ColorField } from '@molecules';
import useEventColors from '@hooks/useEventColors';

import Form from '../Form';

import { FORM_FIELD, INITIAL_VALUES } from './constants';
import Item from './Item';
import AddArticleForm from './AddArticleForm';
import SlideItem from './SlideItem';
import s from './styles.module.less';

const LifestyleGrid = ({ visible, onSubmit, hide, previewImg, onDelete, initialValues = INITIAL_VALUES, errors }) => {
  const [form] = Form.useForm(FORM_FIELD);
  const eventColors = useEventColors();

  const handleAddArticle = (article) => {
    form.setFieldsValue({
      [FORM_FIELD.SLIDES.name]: [...form.getFieldValue('slides'), article],
    });
  };

  const handleClose = React.useCallback(() => {
    form.resetFields();
    hide();
  }, [form, hide]);

  const handleOk = React.useCallback(
    (values) => {
      onSubmit(values);
      handleClose();
    },
    [onSubmit, handleClose],
  );

  return (
    <ContentModuleModal
      visible={visible}
      title="Lifestyle grid"
      subtitle={
        <>
          <div>Add articles to appear in a featured grid.</div>
          <div>You need to choose 2 or 4 articles.</div>
        </>
      }
      okText={onDelete ? 'SAVE CHANGES' : 'ADD LIFESTYLE GRID'}
      onCancel={handleClose}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <AddArticleForm onSubmit={handleAddArticle} />
      <Form form={form} layout="vertical" initialValues={initialValues} onSerializedFinish={handleOk}>
        <div className={s.slidesList}>
          <Form.WithFieldValue name={FORM_FIELD.SLIDES.name}>
            {() => (
              <SortableArrayField form={form} {...FORM_FIELD.SLIDES} withPlaceholder withCount>
                {(value) => <SlideItem slide={value} />}
              </SortableArrayField>
            )}
          </Form.WithFieldValue>
        </div>
        <TextField {...FORM_FIELD.TITLE} />
        <ColorField {...FORM_FIELD.BACKGROUND_COLOR} style={NO_MARGIN_BOTTOM} mergeColors={eventColors} />
      </Form>
    </ContentModuleModal>
  );
};

LifestyleGrid.Item = Item;

export default LifestyleGrid;
